import { create } from 'zustand';

/**
 * App-managed navigation stack for back/forward in the UXP webview. Browser
 * history doesn't expose a forward-stack length, so we track paths ourselves
 * (same pattern as the Shopify plugin).
 */
type NavigationHistoryState = {
  stack: string[];
  index: number;
};

type NavigationHistoryActions = {
  push: (pathname: string) => void;
  back: () => string | null;
  forward: () => string | null;
};

type NavigationHistoryStore = NavigationHistoryState & NavigationHistoryActions;

export const useNavigationHistoryStore = create<NavigationHistoryStore>()((set, get) => ({
  back: () => {
    const { stack, index } = get();

    if (index <= 0) {
      return null;
    }

    const next = index - 1;
    set({ index: next });

    return stack[next];
  },

  forward: () => {
    const { stack, index } = get();

    if (index >= stack.length - 1) {
      return null;
    }

    const next = index + 1;
    set({ index: next });

    return stack[next];
  },

  index: -1,

  push: (pathname) =>
    set((s) => {
      if (s.stack[s.index] === pathname) {
        return s;
      }

      const stack = [...s.stack.slice(0, s.index + 1), pathname];

      return { index: stack.length - 1, stack };
    }),

  stack: [],
}));
